(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileO365OnedriveFilePermissions', ["path", "widgetPolling", function (path, widgetPolling) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/o365_onedrive_file/o365_onedrive-file-permissions').template('o365_onedrive-file-permissions'),
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.parentModel = widgetPolling.scope();
                $scope.isRendered = false;
                $scope.$watch('parentModel.entityData', function () {
                    if (!_($scope.parentModel.entityData).isEmpty() && !$scope.isRendered) {
                        $scope.isRendered = true;
                        $scope.panel = {
                            type: 'data-table',
                            logic: {
                                name: 'filePermissionLogic',
                                entityType: 'o365_onedrive_file',
                                data: $scope.parentModel.entityData && $scope.parentModel.entityData.permissions || [],
                                entityData: $scope.parentModel.entityData
                            },
                            size: 'col-lg-12 col-md-12 col-sm-12 col-xm-12',
                            bodyStyle: { height: '415px' },
                            class: 'light medium-icons vertical-middle',
                            wrapper: {
                                type: 'widget-panel',
                                title: 'Permissions',
                                class: 'avanan white-body overflow-auto',
                                showLoading: false
                            },
                            options: { checkboxes: false },
                            columns: [
                                {
                                    id: 'id',
                                    hidden: true,
                                    primary: true
                                },
                                {
                                    id: 'thumbnail_photo',
                                    text: false,
                                    converter: 'userImageConverter',
                                    converterArgs: {
                                        type: 'type',
                                        saas: 'o365_onedrive'
                                    },
                                    dataStyle: { width: '40px' }
                                },
                                {
                                    id: 'displayName',
                                    text: 'Username',
                                    converter: 'userWithEmail',
                                    converterArgs: {
                                        userIdColumn: 'id',
                                        emailColumn: 'email',
                                        isExternalColumn: 'is_external',
                                        userLinkEntityType: 'o365_onedrive_user'
                                    }
                                },
                                {
                                    id: 'email',
                                    hidden: true
                                },
                                {
                                    id: 'type',
                                    hidden: true
                                },
                                {
                                    id: 'is_external',
                                    hidden: true
                                },
                                {
                                    id: 'roles',
                                    text: 'Type',
                                    type: 'tag',
                                    style: { 'text-align': 'center' },
                                    dataStyle: { 'text-align': 'center' }
                                },
                                {
                                    id: 'can_view',
                                    text: 'Can view',
                                    converter: 'booleanCheckConverter'
                                },
                                {
                                    id: 'can_download',
                                    text: 'Can download',
                                    converter: 'booleanCheckConverter'
                                },
                                {
                                    id: 'can_edit',
                                    text: 'Can edit',
                                    converter: 'booleanCheckConverter'
                                },
                                {
                                    id: 'can_share',
                                    text: 'Can share',
                                    converter: 'booleanCheckConverter'
                                },
                                {
                                    id: 'can_delete',
                                    text: 'Can delete',
                                    converter: 'booleanCheckConverter'
                                }
                            ],
                            tags: {
                                write: {
                                    background: '#4ac598',
                                    color: '#FFFFFF'
                                },
                                owner: {
                                    background: '#4ac598',
                                    color: '#FFFFFF'
                                },
                                creator: {
                                    background: '#4ac598',
                                    color: '#FFFFFF'
                                },
                                external: {
                                    background: '#4c99a9',
                                    color: '#FFFFFF'
                                },
                                internal: {
                                    background: '#3ec291',
                                    color: '#FFFFFF'
                                },
                                share: {
                                    background: '#f35428',
                                    color: '#FFFFFF'
                                }
                            }
                        };
                    }
                });
            }
        };
    }]);
}());